'use client';

import { Suspense } from 'react';
import Compliance from '../components/Compliance';
import ComplianceSkeleton from '../components/ComplianceSkeleton';
import type { ComplianceData } from '@/types/compliance';

interface ComplianceClientProps {
  locale: string;
  data: ComplianceData | null;
}

export default function ComplianceClient({ locale, data }: ComplianceClientProps) {
  return (
    <Suspense fallback={<ComplianceSkeleton />}>
      <Compliance locale={locale} data={data} />
    </Suspense>
  );
}
